// Libs
import { ReactElement } from 'react';
import { Button, Icon } from 'ui-components';
import Link from 'next/link';
import { useRouter } from 'next/router';
import clsx from 'clsx';
// App
import navButtonStyles from 'app-shared/lib/layout/shared/header/nav-button.module.scss';
import { UserDetails } from 'app-shared/lib/api/user-access/account';
import { isRouterPathMatchingRoute } from 'app-shared/lib/utils/router.utils';
import { SHOP_ADMIN_ACCOUNT_PAGES_URLS } from '@/fragments/shop-administration/account/account.constants';

const MAX_USER_NAME_LENGTH = 20;

const buildDisplayedUserName = (firstName: string | null): string => {
  const userName = firstName || '';
  const isUserNameTooLong = userName.length > MAX_USER_NAME_LENGTH;

  return (isUserNameTooLong && userName.substring(0, MAX_USER_NAME_LENGTH - 3) + '...') || userName;
};

const UserAvatar = ({ account }: { account: UserDetails }): ReactElement => {
  const router = useRouter();

  if (account) {
    return (
      <Link href={SHOP_ADMIN_ACCOUNT_PAGES_URLS['home']}>
        <Button
          color="secondary"
          startIcon={<Icon name="user"></Icon>}
          className={clsx(
            navButtonStyles.navButton,
            isRouterPathMatchingRoute(router.pathname, SHOP_ADMIN_ACCOUNT_PAGES_URLS['home']) && navButtonStyles.active
          )}
        >
          {buildDisplayedUserName(account.firstName)}
        </Button>
      </Link>
    );
  }

  return null;
};

export default UserAvatar;
